module.exports = __webpack_public_path__ + "static/media/kiszone-specjaly-banner.99fce796.png";